export default __webpack_public_path__ + "static/media/eccom.35d2f1ce.jpg";